<template>
  <b-card>
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            rules="required"
          >
            <b-form-group
              label="Type"
              label-for="Type"
            >
              <v-select
                v-model="internalAuditForm.audit_type"
                class="w-100"
                :options="optionsAuditType"
                label="text"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            rules="required"
          >
            <b-form-group
              label="grading"
              label-for="grading"
            >
              <v-select
                v-model="internalAuditForm.grading"
                class="w-100"
                :options="optionsGrading"
                label="text"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

        </b-col>

        <b-col md="6">
          <validation-provider
            #default="validationContext"
            rules="required"
          >
            <b-form-group
              label="select Auditors"
              label-for="select Auditors"
            >
              <v-select
                v-model="internalAuditForm.auditors"
                :options="optionsEmployee"
                text-field="label"
                value="value"
                placeholder="Auditors"
                multiple
                :clearable="false"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col md="6">
          <validation-provider
            #default="validationContext"
            rules="required"
          >
            <b-form-group
              label="select department"
              label-for="select department"
            >
              <b-form-select
                v-model="internalAuditForm.department_id"
                :options="optionsDepertment"
                trim
                placeholder="Department"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            rules="required"
          >
            <b-form-group
              label="select department head"
              label-for="select department head"
            >
              <v-select
                v-model="internalAuditForm.department_head_id"
                :options="optionsEmployee"
                text-field="label"
                value="value"
                placeholder="head department"
                :clearable="false"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col md="6">
          <validation-provider
            #default="validationContext"
            rules="required"
          >
            <b-form-group
              label="Details"
              label-for="Details"
            >
              <b-form-textarea
                v-model="internalAuditForm.audit_details"
                placeholder="Add details for this audit"
                :clearable="false"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- Server Errors -->
        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, key, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addInternalAudit()"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="!loader && !$route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addInternalAudit()"
          >
            Add
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VSelect from 'vue-select'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {
    'v-select': VSelect,
  },
  data() {
    return {
      required,
      loader: false,
      validationErrors: {},
      errors: {},
      optionsAuditType: [
        { value: 'internal', text: 'Internal Audit' },
        { value: 'external', text: 'External Audit' },
        { value: 'special', text: 'Special Audit' },
      ],
      optionsGrading: [
        { value: 'non-conformity', text: 'Non Conformity' },
        { value: 'observation', text: 'Observation' },
      ],
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const internalAuditForm = ref({
    })
    return {
      getValidationState,
      internalAuditForm,
    }
  },
  computed: {
    optionsEmployee() {
      return this.$store.getters['generalData/engineersList/engineersList']
    },
    optionsDepertment() {
      return this.$store.getters['generalData/departments/departments']
    },
  },
  async  mounted() {
    if (!this.$store.getters['generalData/engineersList/engineersLoaded']) {
      await this.$store.dispatch('generalData/engineersList/fetchEngineersList')
    }
    if (!this.$store.getters['generalData/departments/departmentsLoaded']) {
      await this.$store.dispatch('generalData/departments/fetchDepartments')
    }
    if (this.$route.params.id) {
      this.getAuditDetails()
    }
  },
  methods: {
    getAuditDetails() {
      axios
        .get(`internal-audit/${this.$route.params.id}`)
        .then(res => {
          const internalAudit = decryptData(res.data.payload).data.resource
          this.internalAuditForm = internalAudit
          this.internalAuditForm.auditors = internalAudit.auditors.map(item => ({
            value: item.id,
            label: item.name,
          }))
          this.internalAuditForm.department_id = internalAudit.department.id
          this.internalAuditForm.department_head_id = {
            label: internalAudit.departmentHead.name,
            value: internalAudit.departmentHead.id,
          }
        })
        .catch(error => {
          this.$toasted.show(error, {
            position: 'top-center',
            duration: 3000,
          })
        })
    },

    addInternalAudit() {
      if (this.$route.params.id) {
        this.loader = true

        const formData = new FormData()
        formData.append('_method', 'PUT')
        // Use Object.entries() to iterate over the object's own properties
        Object.entries(this.internalAuditForm).forEach(([key, value]) => {
          if (key === 'auditors') {
            value.map((item, index) => formData.append(`auditors[${index}]`, item.value))
          } else if (key === 'audit_type' && typeof value === 'object') {
            formData.append(key, value.value)
          } else if (key === 'grading' && typeof value === 'object') {
            formData.append(key, value.value)
          } else if (key === 'department_head_id' && typeof value === 'object') {
            formData.append(key, value.value)
          } else {
            formData.append(key, value)
          }
        })

        axios
          .post(`internal-audit/${this.$route.params.id}`, formData)
          .then(res => {
            if (res.status === 200) {
              this.$router.push({ name: 'internal-audit' })
              this.$toasted.show('Updated Successfully', {
                position: 'top-center',
                duration: 3000,
              })
            }
          })
          .catch(error => {
            if (error.response.status) {
              const payload = decryptData(error.response.data.payload).message
              const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
              const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `${errorMessage}`,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            }
          })
          .finally(() => {
            this.loader = false
          })
      } else {
        this.loader = true
        const formData = new FormData()

        // Use Object.entries() to iterate over the object's own properties
        Object.entries(this.internalAuditForm).forEach(([key, value]) => {
          if (key === 'auditors') {
            value.map((item, index) => formData.append(`auditors[${index}]`, item.value))
          } else if (key === 'audit_type' || key === 'grading' || key === 'department_head_id') {
            formData.append(key, value.value)
          } else {
            formData.append(key, value)
          }
        })

        axios
          .post('internal-audit', formData)
          .then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$router.push({ name: 'internal-audit' })
              this.$toasted.show('Created Successfully', {
                position: 'top-center',
                duration: 3000,
              })
            }
          })
          .catch(error => {
            if (error.response.status) {
              const payload = decryptData(error.response.data.payload).message
              const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
              const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `${errorMessage}`,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            }
          })
          .finally(() => {
            this.loader = false
          })
      }
    },

  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
